<template>
    <div class="credit-media" v-if="!creditOnly">
        <template v-if="video">
            <img class="rmnp-hidden" :alt="$attrs.alt ?? ''" :src="$attrs.poster" v-bind="{ width: $attrs.width, height: $attrs.height }" />
            <video class="rm-hidden" v-bind="$attrs" autoplay playsinline muted loop></video>
        </template>
        <img v-else v-bind="$attrs" />
    </div>
</template>
<script>
export default {
    inheritAttrs: false,

    props: {
        artist: String,
        artwork: String,
        thumbnail: String,
        creditOnly: Boolean,
        video: Boolean,
        commission: {
            default: null,
            type: Boolean,
        },
        weighting: {
            default: "center",
            type: String,
        },
    },

    mounted() {
        this.$store.commit("creditMedia/addMedia", {
            id: this._uid,
            artist: this.artist,
            artwork: this.artwork,
            thumbnail: this.thumbnail,
            weighting: this.weighting,
            commission: this.commission,
        });
    },

    beforeDestroy() {
        this.$store.commit("creditMedia/removeMedia", this._uid);
    },
};
</script>
